/* ============================================================================
   tne-hero.js — Hero Cinematic TopBioEuropa.

   Responsabilidades:
   1. Arrancar o vídeo de fundo (muted, loop) no momento certo:
        - Se o loading screen ainda existe → espera pelo evento
          `tne:loader-hidden` (disparado pelo tne-loader.js) para arrancar
          exactamente quando o loader termina.
        - Se já não há loader (2.ª navegação da sessão, design mode) →
          arranca de imediato.
        - Safety timeout: arranca à força após SAFETY_MS caso o evento se
          perca por algum motivo.
        - prefers-reduced-motion: NÃO arranca o vídeo (fica o poster).
   2. Indicador de scroll: clique faz scroll suave até à secção seguinte.

   Re-inicializa em shopify:section:load para funcionar no Theme Editor.
   ============================================================================ */

(function () {
  'use strict';

  var SAFETY_MS = 3000; // fallback caso o evento do loader nunca dispare

  function prefersReducedMotion() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initVideo(hero) {
    var video = hero.querySelector('[data-tne-hero-video]');
    if (!video) return;

    // Respeita preferência de movimento reduzido: mantém o poster estático.
    if (prefersReducedMotion()) return;

    // Performance mobile: em ecrãs estreitos (ou com poupança de dados activa)
    // NÃO descarregamos nem reproduzimos o vídeo de fundo — fica o poster
    // responsivo. Como o <video> tem preload="none", basta não chamar play()
    // para que nenhum byte do vídeo seja pedido. Poupa vários MB e melhora
    // o LCP/TBT no telemóvel. O vídeo continua igual no desktop (>= 750px).
    var narrowScreen = window.matchMedia &&
      window.matchMedia('(max-width: 749px)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    if (narrowScreen || saveData) return;

    var started = false;

    function play() {
      if (started) return;
      started = true;

      // Garante mute (autoplay programático só é permitido em vídeo mudo).
      video.muted = true;
      video.defaultMuted = true;

      try { video.currentTime = 0; } catch (e) { /* noop */ }

      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(function () {
          video.classList.add('is-playing');
        }).catch(function () {
          // Autoplay recusado — fica o poster. Não força nada.
        });
      } else {
        video.classList.add('is-playing');
      }
    }

    // Se o loader já não está no DOM, arranca já. Caso contrário, espera o
    // evento de fim do loader (com safety timeout).
    if (!document.getElementById('TneLoader')) {
      play();
    } else {
      document.addEventListener('tne:loader-hidden', play, { once: true });
      window.setTimeout(play, SAFETY_MS);
    }
  }

  function initRotator(hero) {
    var rotator = hero.querySelector('[data-tne-rotator]');
    if (!rotator) return;

    var words = rotator.querySelectorAll('.tne-hero__rotator-word');
    if (words.length < 2) return;

    // Reduced-motion: não roda — fica a primeira palavra (já is-active).
    if (prefersReducedMotion()) return;

    var interval = parseInt(rotator.getAttribute('data-interval'), 10);
    if (!interval || interval < 600) interval = 2400;

    var idx = 0;
    window.setInterval(function () {
      words[idx].classList.remove('is-active');
      words[idx].setAttribute('aria-hidden', 'true');
      idx = (idx + 1) % words.length;
      words[idx].classList.add('is-active');
      words[idx].removeAttribute('aria-hidden');
    }, interval);
  }

  function initScrollCue(hero) {
    var cue = hero.querySelector('[data-tne-hero-scroll]');
    if (!cue) return;

    cue.addEventListener('click', function () {
      var wrapper = hero.closest('.shopify-section') || hero;
      var next = wrapper.nextElementSibling;
      if (next) {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: hero.offsetHeight, behavior: 'smooth' });
      }
    });
  }

  function init(root) {
    var scope = root || document;
    var hero = scope.querySelector('[data-tne-hero]');
    if (!hero) return;
    initVideo(hero);
    initRotator(hero);
    initScrollCue(hero);
  }

  init();

  // Theme Editor — re-inicializa quando a secção é recarregada.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
